import { cva } from 'class-variance-authority';

const checkboxBaseStyles = [
  'peer',
  'form-checkbox',
  'appearance-none',
  'cursor-pointer',
  'transition-all',
  'border-1',
  'border-solid',
  'w-4',
  'h-4',

  'focus:ring-0',
  'focus:ring-transparent',
  'focus:ring-offset-0',
  'focus:outline-none',
  'focus-visible:ring-2',
  'focus-visible:outline-2',
  'focus-visible:outline-offset-4',

  'disabled:cursor-not-allowed',
];

const checkboxStylesSAG = cva([
  ...checkboxBaseStyles,
  'border-[#000028]',
  'hover:border-[#005159]',
  'hover:checked:border-[#196269]',
  'focus:checked:border-[#005159]',
  'focus:border-[#000028]',
  'checked:border-[#005159]',

  'bg-white',
  'hover:bg-[#D1FFF2]',
  'hover:checked:bg-[#196269]',
  'focus:checked:bg-[#005159]',
  'checked:bg-[#005159]',

  'checked:bg-checkbox-sag',
  'hover:checked:bg-checkbox-hover-sag',
  'focus:checked:bg-checkbox-hover-sag',

  'disabled:bg-white',
  'disabled:hover:bg-white',
  'disabled:hover:border-[#B3B3BE]',
  'disabled:border-[#B3B3BE]',
  'disabled:checked:bg-checkbox-disabled-sag',
  'disabled:checked:bg-[#B3B3BE]',
  'disabled:checked:hover:bg-[#B3B3BE]',

  // Dark mode
  'dark:border-white',
  'dark:hover:border-[#00FFB9]',
  'dark:hover:checked:border-[#00E5AA]',
  'dark:focus:checked:border-[#00FFB9]',
  'dark:focus:border-[#FFFFFF]',
  'dark:checked:border-[#00FFB9]',

  'dark:bg-[#000028]',
  'dark:hover:bg-[#001F39]',
  'dark:hover:checked:bg-[#00E5AA]',
  'dark:focus:checked:bg-[#00FFB9]',
  'dark:checked:bg-[#00FFB9]',

  'dark:checked:bg-checkbox-dark-sag',
  'dark:hover:checked:bg-checkbox-hover-dark-sag',
  'dark:focus:checked:bg-checkbox-hover-dark-sag',

  'dark:disabled:bg-[#000028]',
  'dark:disabled:border-[#737389]',
  'dark:disabled:checked:bg-checkbox-disabled-dark-sag',
  'dark:disabled:checked:bg-[#737389]',
  'dark:disabled:hover:border-[#737389]',
]);
const checkboxStylesSHS = cva([
  ...checkboxBaseStyles,
  'rounded-sm',

  'border-[#666666]',
  'hover:border-[#666666]',
  'hover:checked:border-[#D45C01]',
  'focus:checked:border-[#D45C01]',
  'focus:border-[#666666]',
  'checked:border-[#D45C01]',

  'bg-white',
  'hover:bg-[#F2F2F2]',
  'hover:checked:bg-[#D45C01]',
  'focus:checked:bg-[#D45C01]',
  'checked:bg-[#D45C01]',

  'disabled:bg-transparent',
  'disabled:hover:bg-transparent',
  'disabled:hover:border-[#C2C2C2]',
  'disabled:border-[#C2C2C2]',
  'disabled:checked:bg-checkbox-disabled-sag',

  // Dark mode
  'dark:border-[#999999]',
  'dark:hover:border-[#999999]',
  'dark:hover:checked:border-[#D45C01]',
  'dark:focus:checked:border-[#D45C01]',
  'dark:focus:border-[#999999]',
  'dark:checked:border-[#D45C01]',

  'dark:bg-[#1A1A1A]',
  'dark:hover:bg-[#313131]',
  'dark:hover:checked:bg-[#D45C01]',
  'dark:focus:checked:bg-[#D45C01]',
  'dark:checked:bg-[#D45C01]',

  'dark:disabled:bg-transparent',
  'dark:disabled:hover:bg-transparent',
  'dark:disabled:hover:border-[#C2C2C2]',
  'dark:disabled:border-[#C2C2C2]',
  'dark:disabled:checked:bg-checkbox-disabled-sag',
]);

export { checkboxStylesSAG, checkboxStylesSHS };
